export * from "./services/localization.service";
export * from "./localization.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/behaviors/localization/index.js
// module id = 43
// module chunks = 0